import storage from '@core/lib/storage/storage';

function Storage() {
  'ngInject';
  return storage;
}

export { Storage };
